import { render } from "./addUser.vue?vue&type=template&id=280edb78&scoped=true"
import script from "./addUser.vue?vue&type=script&lang=js"
export * from "./addUser.vue?vue&type=script&lang=js"

import "./addUser.vue?vue&type=style&index=0&id=280edb78&scoped=true&lang=css"
import "./addUser.vue?vue&type=style&index=1&id=280edb78&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280edb78"]])

export default __exports__